export default __webpack_public_path__ + "static/media/career_exploration_icon.ef03369c.png";